<template>
  <div>
    <PrintMailDataTable
        :loading="loading"
        :mails="mails"
        :total="total"
        @update="onUpdate"
        @create-print-package="onCreatePrintPackage"
        @create-print-package-after-postindex="onCreatePrintPackageAfterPostIndex"
        :allow-create-print-package="allowCreatePrintPackage"
    />
    <v-snackbar v-model="noMailsToPrint"
                :timeout="5000"
                :top="true"
                color="info"
    >
      Нет писем для распечатки
    </v-snackbar>
    <v-snackbar v-model="temporaryUnavailable"
                :timeout="5000"
                :top="true"
                color="warning"
    >
      Создание новой печати временно недоступен
    </v-snackbar>
  </div>
</template>
<script>
import MailService from '@/services/mail.service'
import PrintPackageService from '@/services/print.package.service'
import Mappers from '@/mappers'
import _ from 'underscore'
import Moment from 'moment'
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import {AllowCreatePrintPackage} from "@/enums/permission";
import PrintJS from 'print-js'
import {EHM} from '@/enums/client'
import {LimitPerPrintPackage} from '@/settings/server'
import {LimitPerPrintPackageEhm} from '@/settings/server'
import PrintMailDataTable from "@/components/PrintMailDataTable.vue";
export default {
  name: "MailsView",
  components: {
    PrintMailDataTable,
  },
  data() {
    return {
      mails: [],
      total: 0,
      loading: false,
      noMailsToPrint: false,
      temporaryUnavailable: false,
    }
  },
  computed: {
    mailsToPrint() {
      return _.chain(this.mails)
          .filter(function (mail) {
            return mail.isPrinted === false
          })
          .map(function (mail) {
            return mail.uid
          })
          .value()
    },
    allowCreatePrintPackage() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePrintPackage
      })
    },
    isAllowMailsListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePrintPackage
      })
    },
    printPackageLimit() {
      let paginationSize = this.$route.query && this.$route.query.itemsPerPage ? +this.$route.query.itemsPerPage : 50
      if (this.$store.getters.appActiveClient === EHM) {
        if (paginationSize <= LimitPerPrintPackageEhm) {
          return paginationSize;
        } else {
          return LimitPerPrintPackageEhm;
        }
      } else {
        if (paginationSize <= LimitPerPrintPackage) {
          return paginationSize;
        } else {
          return LimitPerPrintPackage;
        }
      }
    },
  },
  methods: {
    reloadMails(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {region, area, postIndex, isDistributed, isPrinted, isPosted, isPerformed, isTransferNotified, isTransferCompleted, isExpress, performTypes, start, end} = filters;

      const skip = (page - 1) * itemsPerPage;

      MailService.getPrintDataTable({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        postIndex: postIndex,
        isDistributed: isDistributed,
        isPrinted: isPrinted,
        isPosted: isPosted,
        isPerformed: isPerformed,
        isTransferNotified: isTransferNotified,
        isTransferCompleted: isTransferCompleted,
        isExpress: isExpress,
        performTypes: performTypes,
        start: start ? Moment(start, 'YYYY-MM-DD') : null,
        end: end ? Moment(end, 'YYYY-MM-DD') : null
      })
          .then(response => {
            this.mails = _.map(response.data.Records, mailViewModel => {
              return Mappers.mapMail(mailViewModel)
            })
            this.total = response.data.Total;
          }, () => {
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onUpdate(options, filters) {
      this.reloadMails(options, filters)
    },
    onCreatePrintPackageAfterPostIndex(options, filters, mails){
      const {region, area} = filters;
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.noMailsToPrint = false

      PrintPackageService.createPrintPackage({
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        mails: mails
      })
          .then(response => {
            if (response.status === 204) {
              this.noMailsToPrint = true
            } else {
              const printPackage = Mappers.mapPrintPackage(response.data)
              const path = PrintPackageService.getPdfPath(printPackage)

              PrintJS({
                printable: path,
                type: 'pdf',
                showModal: true,
                modalMessage: 'Подождите, идет загрузка для печати'
              })
            }
          })
          .catch((error) => {
            if (error) {
              switch (error.response.status) {
                case 409: this.temporaryUnavailable = true; break;
              }
            }

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)

            this.reloadMails(options, filters)
          })
    },
    onCreatePrintPackage(options, filters) {
      const {region, area} = filters;
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.noMailsToPrint = false

      PrintPackageService.createPrintPackage({
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        mails: this.mailsToPrint
      })
          .then(response => {
            if (response.status === 204) {
              this.noMailsToPrint = true
            } else {
              const printPackage = Mappers.mapPrintPackage(response.data)
              const path = PrintPackageService.getPdfPath(printPackage)

              PrintJS({
                printable: path,
                type: 'pdf',
                showModal: true,
                modalMessage: 'Подождите, идет загрузка для печати'
              })
            }
          })
          .catch((error) => {
            if (error) {
              switch (error.response.status) {
                case 409: this.temporaryUnavailable = true; break;
              }
            }

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)

            this.reloadMails(options, filters)
          })
    },
  },
  created() {
    if (this.isAllowMailsListing) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Письма')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>
